import { useLanguage } from '../contexts/LanguageContext';

export function HowItWorks() {
  const { t } = useLanguage();

  const steps = [
    {
      number: t.howItWorks.step1.number,
      title: t.howItWorks.step1.title,
      description: t.howItWorks.step1.description,
    },
    {
      number: t.howItWorks.step2.number,
      title: t.howItWorks.step2.title,
      description: t.howItWorks.step2.description,
    },
    {
      number: t.howItWorks.step3.number,
      title: t.howItWorks.step3.title,
      description: t.howItWorks.step3.description,
    },
  ];

  return (
    <div className="how-it-works">
      <h2>{t.howItWorks.title}</h2>
      
      <div className="steps">
        {steps.map((step) => (
          <div key={step.number} className="step">
            <div className="step-number">
              {step.number}
            </div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
